export default "__VITE_ASSET__CofKrtIP__"